// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3AZDV","modalForm":"UpgradeEpcsModal_modalForm__1i4m9","modalFooter":"UpgradeEpcsModal_modalFooter__16g9Q"};